import { actionCreator, ActionReturnType } from "@itk/typescript-utils";

export enum Action {
  SetIsShowingAddEditLabel = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:ADD-EDIT-LABEL:ADD-EDIT-LABEL-STORE.TS:ACTION:SETISSHOWINGADDEDITLABEL"
}

type TAddEditLabelState = {
  isShowingAddEditLabel: boolean;
};

const initialState: TAddEditLabelState = {
  isShowingAddEditLabel: false
};

export const addEditLabelActions = {
  setIsShowingAddEditLabel: (data: boolean) => actionCreator(Action.SetIsShowingAddEditLabel, { data })
};

export const addEditLabelReducer = (state = initialState, action: ActionReturnType<typeof addEditLabelActions>): TAddEditLabelState => {
  switch (action.type) {
    case Action.SetIsShowingAddEditLabel:
      return { ...state, isShowingAddEditLabel: action.payload.data };

    default:
      return state;
  }
};
